import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { gameInfoJson, giftCodeJson, RecommendDataJson, userStrategyListJson } from '@/views/system/gameDetail/typings';

export interface boxGameCodeProps {
  giftCode: giftCodeJson[];
  box_game_id?: number;
  cTime?: number;
}

export interface recommendProps {
  recommend: RecommendDataJson;
  factory_id: number;
  box_game_id?: number;
  cTime?: number;
}

export interface userStrategyListProps {
  box_game_id?: number;
  cTime?: number;
  userStrategyList: userStrategyListJson[];
}

export interface GameDetailsState {
  boxGameDetail: gameInfoJson[];
  giftCode: boxGameCodeProps[];
  gameRecommend: recommendProps[];
  userStrategyList: userStrategyListProps[];
}

const GAMEDETAIL_KEY = 'React-ts-ant-gameDetail';

const localGameDetails = LocalStore.getValue<GameDetailsState>(GAMEDETAIL_KEY) || {};

export const defaults: GameDetailsState = {
  boxGameDetail: [],
  giftCode: [],
  gameRecommend: [],
  userStrategyList: [],
  ...localGameDetails
};

const GAME_DETAIL_KEY = 'React-ts-ant-GAMEDETAILS';

export const updateGameDetails: (gameDetails: GameDetailsState) => IAction<GameDetailsState> = (
  gameDetails: GameDetailsState
) => ({
  type: GAME_DETAIL_KEY,
  payload: gameDetails
});

const gameDetailReducer: Reducer<GameDetailsState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case GAME_DETAIL_KEY:
      LocalStore.setValue(GAMEDETAIL_KEY, payload as GameDetailsState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default gameDetailReducer;
